/**
 * List of all the marks and types we use in Portable Editor Blocks.
 * This allows us to refer to them by their constant symbol, rather than a magic string, in both
 * the Sanity Studio app, and the web app.
 */

export enum MARKS {
  PAGE_LINK = 'pageLink',
  URL_LINK = 'urlLink',
  COLORED = 'colored',
  PAGE_ANCHOR = 'pageAnchor',
  JAVASCRIPT_LINK = 'javascriptLink',
  INTERNAL_TEXT_LINK = 'internalTextLink',
}

export enum BLOCKS {
  BLOCK = 'block',
  IMAGE = 'image',
  /**
   * Native Portable Text table (@portabletext/plugin-table), enabled through the
   * Studio's `form.components.portableText.plugins` config.
   * The container types stay namespaced - they were introduced alongside a legacy
   * `table` type and the names are now baked into existing documents.
   */
  MARKUP_TABLE = 'markupTable',
  MARKUP_TABLE_ROW = 'markupTableRow',
  MARKUP_TABLE_CELL = 'markupTableCell',
  VIDEO = 'video',
  DATA = 'data',
  SURPRISE_BAG_CARD = 'surpriseBagCard',
}

export enum SURPRISE_BAG_CARD_SOURCE {
  ID = 'id',
  LOCATION = 'location',
}

export enum LIST {
  BULLET = 'bullet',
  NUMBER = 'number',
  TICK = 'tick',
}

export enum STYLE {
  H1_HIGHLIGHT = 'h1-highlight',
  H2_HIGHLIGHT = 'h2-highlight',
  H3_TENON = 'h3-tenon',
  H5_TENON = 'h5-tenon',
  BODY_LARGE = 'body-large',
  BODY_SMALL = 'body-small',
  BODY_XSMALL = 'body-xsmall',
}
